module.exports = __webpack_public_path__ + "img/per_query.562657b2.png";